export class TicketComments {
    Id: number;
    TicketId: number;
    CreatedBy: number;
    CreatedDate: string;
    Body: string;
    LocationId: number;
}